import React from "react";
import { useTranslationV3 } from "../../i18nV3/useTranslationV3";
import { Title, Text } from "./components/Typography";

const ErrorView = () => {
  const { t } = useTranslationV3();

  return (
    <>
      <Title>{t("lp_cancellation_error_title")}</Title>
      <Text>{t("lp_cancellation_error_content")}</Text>
    </>
  );
};

export default ErrorView;
